<template>
  <row class="loginForm">
    <column class="col-md-8">
      <va-box title="Account Info" theme="box-info" :isBorder="true" widgetType="">
        <div slot="content">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 control-label">Account Name</label>
              <div class="col-sm-10">
                <input type="text" class="form-control" placeholder="Full Name" v-model="account.fullname" readonly disabled style="cursor: text" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">Email</label>
              <div class="col-sm-10">
                <input type="email" class="form-control" placeholder="Email" v-model="account.username" readonly disabled style="cursor: text" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">Auth Key</label>
              <div class="col-sm-10">
                <input type="email" class="form-control" placeholder="Auth Key" v-model="$root.user.AuthKey" readonly disabled style="cursor: text" />
              </div>
            </div>
            <!-- <div>
                     <label class="col-sm-2 control-label"></label>
              <contact-us class="col-sm-10"></contact-us>
            <!--</div>
           <!--  <div class="form-group">
          <label class="col-sm-2 control-label">Password</label>
          <div class="col-sm-10">
            <input type="password" class="form-control" placeholder="Password" v-model="password" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">Confirm Password</label>
          <div class="col-sm-10">
            <input type="password" class="form-control" placeholder="Confirm Password" v-model="password" />
          </div>
        </div>-->
            <va-alert :type="alertType" :dismissible="true" v-show="error">
              <div slot="body">
                <i v-if="alertType==='success'" class="icon fa fa-check"></i>
                <i v-else class="icon fa fa-ban"></i> {{error}}
              </div>
            </va-alert>
          </form>
        </div>
        <div slot="footer">
          <!--<va-button :isBlock="false" theme="danger" name="Cancel" align="right"></va-button>
      <va-button :isBlock="false" theme="success" align="right" name="Save" style="margin-right: 10px;"></va-button>-->
          <div class="form-group">
            <label class="col-sm-2 control-label"></label>
            <div class="col-sm-10" style="text-align: right; cursor: pointer;">
              <a class="control-label" @click="sendResetPassword()">Reset Password</a>
            </div>
          </div>
        </div>
      </va-box>
      <!-- <va-box title="Site Authentication" theme="box-info" :isBorder="true" widgetType="" style="display: none;">
    <div slot="content">
      <form class="form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">Email</label>
          <div class="col-sm-10">
            <input type="email" class="form-control" placeholder="Email" v-model="siteAuth.username" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">Password</label>
          <div class="col-sm-10">
            <input type="password" class="form-control" placeholder="Password" v-model="siteAuth.password" />
          </div>
        </div>
      </form>
    </div>
    <div slot="footer">
      <va-button :isBlock="false" theme="danger" name="Cancel" align="right"></va-button>
      <va-button @click.native="saveSiteAuth" :isBlock="false" theme="success" align="right" name="Save" style="margin-right: 10px;"></va-button>
    </div>
  </va-box>
  <va-alert type="danger" :dismissible="true" v-show="error2">
    <div slot="body">
      <i class="icon fa fa-ban"></i> {{error2}}
    </div>
  </va-alert>-->
    </column>
  <column class="col-md-4">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
      <img :src="logoPath" class="user-image roundImage" alt="User Image" style="width: 160px;">
    </a>
    <br />
    <br />
    <label action="#" method="get" style="margin: 0px; border: none;">
      <div class="input-group btnUpload" style="padding: 5px 10px;width: 160px; text-align: center; color: green;">
        <span class="btnUpload">Upload Logo</span>
        <input type="file" @change="uploadLogo" />
      </div>
      </label>
    </column>
</row>
</template>
<script>
  import VABox from '../components/VABox'
  import VAInputGroup from '../components/VAInputGroup'
  import VACheckBox from '../components/VACheckBox'
  import VAInput from '../components/VAInput'
  import VAButton from '../components/VAButton'
  import VATextareaGroup from '../components/VATextareaGroup'
  import VAFormGroup from '../components/VAFormGroup'
  import VARadio from '../components/VARadio'
  import VASelect from '../components/VASelect'
  import VAAlert from '../components/VAAlert'
  import contact from '../components/Home/contact'

  import { db, auth, storage } from '../firebase'

  export default {
    name: 'Account',
    components: {
      'Account': contact,
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-input-group': VAInputGroup,
      'va-checkbox': VACheckBox,
      'va-input': VAInput,
      'va-button': VAButton,
      'va-textarea-group': VATextareaGroup,
      'va-form-group': VAFormGroup,
      'va-radio': VARadio,
      'va-select': VASelect
    },
    data () {
      return {
        loading: false,
        username: '',
        password: '',
        siteAuth: { username: '', password: '' },
        alertType: 'danger',
        error: '',
        error1: '',
        error2: '',
        readyFileName: '',
        logoPath: 'https://image.flaticon.com/icons/png/512/149/149071.png'
      }
    },
    created () {
      this.$root.title = 'My Account'
      if (this.$root.user.Logo) {
        this.logoPath = this.$root.user.Logo
      }
    },
    computed: {
      account () {
        return {
          fullname: this.$root.user.FirstName + ' ' + this.$root.user.LastName,
          username: this.$root.user.Email,
          password: '',
          logo: ''
        }
      }
    },
    methods: {
      saveSiteAuth () {
        let vm = this
        if (vm.isValidSiteAuth()) {
          auth.createUserWithEmailAndPassword(vm.siteAuth.username, vm.siteAuth.password).then(function () {
            const siteAuthRef = db.ref('Users/' + vm.$root.user['.key'] + '/SiteAuth')
            siteAuthRef.set(vm.siteAuth)
          })

          vm.reset()
        }
      },
      isValidSiteAuth () {
        this.error2 = ''

        if (this.siteAuth.username.length === 0) {
          this.error2 = '* Please enter Site Authentication Email!'
          return false
        }

        if (this.siteAuth.password.length === 0) {
          this.error2 = '* Please enter Site Authentication Password!'
          return false
        }

        return true
      },
      uploadLogo (e) {
        var vm = this
        vm.readyFileName = ''
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) return

        var file = files[0]
        vm.showProgress = true
        var storagePath = 'Logo/' + file.name
        var storageRef = storage.ref(storagePath)
        var task = storageRef.put(file)

        task.on('state_changed',
          function progress (snap) {
            vm.percent = (snap.bytesTransferred / snap.totalBytes) * 100
            console.log(vm.percent)
          },
          function error (err) {
            vm.showProgress = false
            console.log(err)
          },
          function complete () {
            vm.showProgress = false
            vm.percent = 0
            storage.ref(storagePath).getDownloadURL().then(function (downloadURL) {
              console.log(downloadURL)
              vm.logoPath = downloadURL
              db.ref('Users/' + vm.$root.user['.key'] + '/Logo').set(downloadURL)
              vm.$root.user.Logo = downloadURL
              vm.$localStorage.set('user', JSON.stringify(vm.$root.user))
              location.reload(true)
            })
          }
        )
      },
      sendResetPassword () {
        const vm = this
        console.log('sendResetPassword')
        auth.sendPasswordResetEmail(vm.$root.user.Email).then(() => {
          console.log('email sent!')
          vm.alertType = 'success'
          vm.error = 'Reset Password link was sent to your email.'
          window.setTimeout(function () { vm.error = '' }, 3000)
        }).catch(function (error) {
          console.log(error)
          vm.alertType = 'danger'
          vm.error = error.message
        })
      },
      reset () {

      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  
</style>



// WEBPACK FOOTER //
// Account.vue?131c97f0